import '../../../../css/buttons.css';
import type { ButtonProps } from '../../types/button';

const ButtonDanger = ({ onClick, testId, className, children, ...otherProps }: ButtonProps) => (
    <button
        type="button"
        onClick={onClick}
        data-testid={testId}
        className={`btn btn-danger ${className ?? ''}`}
        {...otherProps}
    >
        {children}
    </button>
);

export default ButtonDanger;
